<template lang="pug">
  transition
    div(v-if="show").wrap-now-loading.f.fh
      div
        img(src='/img/pyokopyoko.gif').pyokopyoko.mb8
        div.f.fc
          span Now Loading
</template>

<style lang="scss" scoped>
.wrap-now-loading {
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  .pyokopyoko {
    display: block;
    width: 220px;
  }
  span {
    color: #ff9999;
  }
}
/* アニメーション中のスタイル */
.v-leave-active,
.v-enter-active {
  transition: opacity 0.4s;
}

/* 表示アニメーション */
.v-enter {
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}

/* 非表示アニメーション */
.v-leave {
  opacity: 1;
}
.v-leave-to {
  opacity: 0;
}
</style>

<script>

export default {
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {

    }
  },
  async created () {

  },
  methods: {
    // ...mapActionsTeam([
    //   'loadMemberUsers'
    // ])
    tweet () {
      this.$emit('tweetPost')
    }
  }
}
</script>
